import React, {useState} from 'react';

import {Button} from "../../../components/Button";
import {TextInputField} from "../../../components/FormField";

const RoomChangeGroupTitle = ({
                                  handleSubmit = () => {
                                  },
                                  groupTitle = "",
                                  handleClose = () => {
                                  }
                              }) => {
    let [title, setTitle] = useState(groupTitle);
    return (
        <div id="changeTitle" className="modal-container">
            <div className="modal-topline">
                Changer le nom du groupe
            </div>
            <div className="modal-body">
                <TextInputField value={title}
                                onChange={(event) => setTitle(event.target.value)}
                                placeholder={"changer le titre ici ..."}
                                onKeyPress={(event) => {
                                    event.key === "Enter" && handleSubmit(title)
                                }}/>
            </div>
            <div className="modal-baseline">
                <Button size="small"
                        btnStyle="grey"
                        onClick={() => handleClose()}
                        content="Annuler"/>
                <Button size="small"
                        btnStyle="primary-reverse"
                        onClick={() => handleSubmit(title)}
                        content="Valider"/>
            </div>
        </div>
    )
}

export default RoomChangeGroupTitle;